export default __webpack_public_path__ + "static/media/real-page-logo.4e12c446.svg";